import { createElement } from 'rlink-react';

export default function IconPopulation (props) {
  return (
    <svg id="Layer_1" viewBox="0 0 231 201" {...props}>
      <g id="p1" fill="#FAE71D">
        <circle cx={33.2} cy={10.8} r={10.1} />
        <path d="M44.9 57.2h-23c-2.8 0-5-2.2-5-5v-24c0-2.8 2.2-5 5-5h23c2.8 0 5 2.2 5 5v24c0 2.7-2.3 5-5 5z" />
        <path d="M36.8 48.4H30c-2.8 0-5 2.2-5 5v37.5c0 2.8 2.2 5 5 5h6.8c2.8 0 5-2.2 5-5V53.4c0-2.8-2.3-5-5-5z" />
      </g>
      <g id="p2" fill="#FAE71D">
        <circle cx={74.3} cy={11.1} r={10.1} />
        <path d="M86 57.5H63c-2.8 0-5-2.2-5-5v-24c0-2.8 2.2-5 5-5h23c2.8 0 5 2.2 5 5v24c0 2.7-2.2 5-5 5z" />
        <path d="M77.9 48.7h-6.8c-2.8 0-5 2.2-5 5v37.5c0 2.8 2.2 5 5 5h6.8c2.8 0 5-2.2 5-5V53.7c0-2.8-2.3-5-5-5z" />
      </g>
      <g id="p3" fill="#FAE71D">
        <circle cx={116.2} cy={10.8} r={10.1} />
        <path d="M127.9 57.2h-23c-2.8 0-5-2.2-5-5v-24c0-2.8 2.2-5 5-5h23c2.7 0 5 2.2 5 5v24c0 2.7-2.2 5-5 5z" />
        <path d="M119.8 48.4H113c-2.8 0-5 2.2-5 5v37.5c0 2.8 2.2 5 5 5h6.8c2.8 0 5-2.2 5-5V53.4c0-2.8-2.2-5-5-5z" />
      </g>
      <g id="p4" fill="#FAE71D">
        <circle cx={157.4} cy={11.1} r={10.1} />
        <path d="M169 57.5h-23c-2.8 0-5-2.2-5-5v-24c0-2.8 2.2-5 5-5h23c2.8 0 5 2.2 5 5v24c0 2.7-2.2 5-5 5z" />
        <path d="M160.9 48.7h-6.8c-2.8 0-5 2.2-5 5v37.5c0 2.8 2.2 5 5 5h6.8c2.8 0 5-2.2 5-5V53.7c0-2.8-2.2-5-5-5z" />
      </g>
      <g id="p5" fill="#FAE71D">
        <circle cx={198.4} cy={11.1} r={10.1} />
        <path d="M210 57.5h-23c-2.8 0-5-2.2-5-5v-24c0-2.8 2.2-5 5-5h23c2.8 0 5 2.2 5 5v24c0 2.7-2.2 5-5 5z" />
        <path d="M201.9 48.7h-6.8c-2.8 0-5 2.2-5 5v37.5c0 2.8 2.2 5 5 5h6.8c2.8 0 5-2.2 5-5V53.7c0-2.8-2.2-5-5-5z" />
      </g>
      <g id="p6" fill="#FAE71D">
        <circle cx={53.4} cy={114.5} r={10.1} />
        <path d="M65.1 160.9h-23c-2.8 0-5-2.2-5-5v-24c0-2.8 2.2-5 5-5h23c2.8 0 5 2.2 5 5v24c0 2.7-2.3 5-5 5z" />
        <path d="M57 152.1h-6.8c-2.8 0-5 2.2-5 5v37.5c0 2.8 2.2 5 5 5H57c2.8 0 5-2.2 5-5v-37.5c0-2.8-2.3-5-5-5z" />
      </g>
      <g id="p7" fill="#FAE71D">
        <circle cx={95.3} cy={114.2} r={10.1} />
        <path d="M107 160.6H84c-2.8 0-5-2.2-5-5v-24c0-2.8 2.2-5 5-5h23c2.8 0 5 2.3 5 5v24c0 2.7-2.2 5-5 5z" />
        <path d="M98.9 151.8h-6.8c-2.8 0-5 2.2-5 5v37.5c0 2.8 2.2 5 5 5h6.8c2.8 0 5-2.2 5-5v-37.5c0-2.8-2.3-5-5-5z" />
      </g>
      <g id="p8" fill="#FAE71D">
        <circle cx={136.4} cy={114.5} r={10.1} />
        <path d="M148.1 160.9h-23c-2.8 0-5-2.2-5-5v-24c0-2.8 2.2-5 5-5h23c2.8 0 5 2.2 5 5v24c0 2.7-2.2 5-5 5z" />
        <path d="M140 152.1h-6.8c-2.8 0-5 2.2-5 5v37.5c0 2.8 2.2 5 5 5h6.8c2.8 0 5-2.2 5-5v-37.5c0-2.8-2.2-5-5-5z" />
      </g>
      <g id="p9" fill="#FAE71D">
        <circle cx={177.4} cy={114.5} r={10.1} />
        <path d="M189.1 160.9h-23c-2.8 0-5-2.2-5-5v-24c0-2.8 2.2-5 5-5h23c2.8 0 5 2.2 5 5v24c0 2.7-2.2 5-5 5z" />
        <path d="M181 152.1h-6.8c-2.8 0-5 2.2-5 5v37.5c0 2.8 2.2 5 5 5h6.8c2.8 0 5-2.2 5-5v-37.5c0-2.8-2.2-5-5-5z" />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/svg/iconPopulation.jsx